import type {
  HealthcareSessionId,
  HealthcareUserId,
  Prospect,
} from '@hc-frontend/core-types';

import type { HandleContextualTrafficRepository } from '../../domain/repositories/handle-contextual-traffic-repository';
import { getLocationParameters } from './get-location-parameters';
import { getParameters } from './get-parameters';
import { updateProspect } from './update-prospect';

export function handleContextualTrafficAdapterFactory({
  baseUrl,
}: {
  baseUrl: string;
}): HandleContextualTrafficRepository {
  return {
    getParameters: (landingUrl) => getParameters({ baseUrl, landingUrl }),
    updateProspect: (
      prospect: Prospect,
      sessionId: HealthcareSessionId,
      userId: HealthcareUserId,
    ) => updateProspect(baseUrl, prospect, sessionId, userId),
    getLocationParameters: (landingUrl) =>
      getLocationParameters({ landingUrl }),
  };
}
